// extracted by mini-css-extract-plugin
module.exports = {"flash":"FormError_flash__IXIuU"};